angular.module('unergie.main')
.controller('consumptionDashboardCtrl', ($scope, DynamicScriptLoaderService) => {
    $scope.displayPage = true

    DynamicScriptLoaderService.load('commons/consumptionDashboard.js')
})
